import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20
  },
  spinner: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  circle: {
    width: 8,
    height: 30,
    borderRadius: 5,
    margin: 5,
    opacity: 0.3,
    transition: 'opacity 0.3s ease-in-out'
  },
  activeCircle: {
    opacity: 1,
    width: 8,
    height: 55
  }
})

export default useStyles
